// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
export enum ColorKey {
  primary = 'primary',
  accent = 'accent',
  warn = 'warn',
}
